<template>
  <DecisionAnalysis />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DecisionAnalysis from "../../components/Apps/DecisionAnalysis/index.vue";

export default defineComponent({
  name: "DecisionAnalysisPage",
  components: {
    DecisionAnalysis,
  },
});
</script>
